import { ShopCategory, ShopInfo, ShopNavBar, ShopBanner } from '../components';
import { Pagination } from 'antd';
import EvaluationCard from './EvaluationCard';
import ScoreCard from './ScoreCard';
import { getDynamicEvaluation } from 'api/shop';
import { useEffect, useState } from 'react';

export default function ShopEvaluation({ shopData }) {
  const [paginationParams, setPaginationParams] = useState({
    pageNo: 1,
    pageSize: 10,
  });
  const [evaluationData, setEvaluationData] = useState({
    datas: [],
    pageNo: 1,
    total: 0,
    totalPage: 0,
    pageSize: 10,
  });

  useEffect(() => {
    let params: any = {
      evaluateObjectType: 2,
      status: 1,
      evaluateObjectSysNo: shopData.supplierSysNo,
      ...paginationParams,
    };
    getDynamicEvaluation({
      json: params,
    }).then(({ data }) => {
      setEvaluationData(data);
    });
  }, [paginationParams, shopData]);
  return (
    <>
      <div className="shop-container">
        <ShopBanner shop={shopData} />
        <ShopNavBar pageType={'evaluation'} />
        <div className="shop-wrap">
          <div className="shop-left">
            <ShopInfo shop={shopData} />
            <ShopCategory
              twoShopCustomCategoryTreeDTOList={shopData.shopCustomCategoryTreeDTOList}
            />
          </div>
          <div className="shop-right">
            <ScoreCard score={shopData.score} />
            {evaluationData.datas.map((item, idx) => {
              return <EvaluationCard key={idx} item={item} />;
            })}
            <div style={{ float: 'right', margin: '10px 0' }}>
              <Pagination
                current={evaluationData.pageNo}
                pageSize={evaluationData.pageSize}
                total={evaluationData.total}
                onChange={(page, pageSize) => {
                  setPaginationParams({ pageNo: page, pageSize });
                }}
                showTotal={() => `共${evaluationData.totalPage}页 / ${evaluationData.total}条记录`}
                showQuickJumper
                showSizeChanger
              />
            </div>
          </div>
        </div>
      </div>

      <style jsx>
        {`
          .shop-container {
            margin-bottom: 20px;
          }
          .shop-right{
            float: right;
            width: 956px;
            height: auto;
            margin-top: 20px;
          }
          .shop-left{
            float: left;
            width: 224px;
            height: auto;
            margin-top: 20px;
          }
          .shop-wrap{
            position: relative;
            width: 1200px;
            margin: 0 auto;
          }
          .shop-wrap:after{
            clear: both;
            display: block;
            content:"";
          }
          `}
      </style>
    </>
  );
}
